import { __rest } from "tslib";
import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@@Hooks/useLang';
import { BreadcrumbElementWrapper, BreadcrumbSeparator, BreadcrumbsWrapper } from './styled';
export const Breadcrumbs = (_a) => {
    var { lastNotActive = true, startFromMainPage = true, noMargin = false, wrap } = _a, props = __rest(_a, ["lastNotActive", "startFromMainPage", "noMargin", "wrap"]);
    const { translate } = useLang();
    const children = props.children instanceof Array ? props.children.filter(child => child) : [props.children];
    return React.createElement(BreadcrumbsWrapper, { lastNotActive: lastNotActive, noMargin: noMargin },
        startFromMainPage && React.createElement(React.Fragment, null,
            React.createElement(BreadcrumbElementWrapper, { key: -1, className: "breadcrumb-el", wrap: wrap },
                React.createElement(Link, { to: "/" }, translate('pages.main'))),
            React.createElement(BreadcrumbSeparator, null, "/")),
        children.map((route, i) => (React.createElement(React.Fragment, { key: i },
            React.createElement(BreadcrumbElementWrapper, { key: i, className: "breadcrumb-el", wrap: wrap }, route),
            i !== children.length - 1 ? React.createElement(BreadcrumbSeparator, null, "/") : null))));
};
